<template>
  <div>
    <div
      class="
        subscription-modal-box subscription-history
        input-container
        theme--light
        v-card
      "
    >
      <v-card>
        <v-card-text class="pa-4">
          <CRow>
            <CCol sm="12" md="12" class="pb-0">
              <h4 class="history-title mb-2">
                Username: {{ this.userInfo.full_name }}
              </h4>
              <h5
                v-if="this.userDetails.role !== 'doctor' && this.userDetails.role !== 'allied' "
                class="history-title mb-2"
              >
                Centre Name:
                {{
                  this.userInfo &&
                  this.userInfo.center &&
                  this.userInfo.center.name
                }}
              </h5>
            </CCol>
          </CRow>
          <CRow>
            <div class="col-md-3 col-sm-6">
              <label for class="d-block-mob fz-12px d-block"
                >Date Range (Date of Purchase )</label
              >
              <div class="datepicker pos-r">
                <datepicker
                  v-model="joinOnDateRange"
                  @input="dateChange()"
                  ref="datepicker"
                  :model-config="datePickerConfig"
                  :max-date="new Date()"
                  is-range
                  :masks="{ input: 'DD/MM/YYYY' }"
                >
                  <template v-slot="{ inputValue, inputEvents }">
                    <input
                      :value="
                        !!inputValue.start && !!inputValue.end
                          ? inputValue.start + ' - ' + inputValue.end
                          : 'DD/MM/YYYY'
                      "
                      v-on="inputEvents.start"
                      class="form-control pos-r"
                      placeholder="DD/MM/YYYY"
                    />
                    <div
                      v-if="!!inputValue.start && !!inputValue.end"
                      class="cross-svg subscription-cross-svg"
                      @click="resetJoiningDate"
                    >
                      <crossSVG />
                    </div>
                  </template>
                </datepicker>
                <div class="calendarsvg pos-a">
                  <calendarSVG />
                </div>
              </div>
            </div>

            <div class="col-sm-6 col-md-3">
              <label for>Select Status</label>
              <select
                @change="filterChange(currentStatus)"
                v-model="currentStatus"
                name
                id
                class="form-control"
              >
                <option value="all">All</option>
                <option value="active">Active</option>
                <option value="expired">Expired</option>
                <option value="upcoming">Upcoming</option>
              </select>
            </div>
            <div class="col-md-3 col-sm-6">
              <label class="col-sm-12 mb-0 d-none-mob1" for></label>
              <v-btn
                :disabled="isEmpty"
                :loading="csvLoader"
                @click="downloadCsv()"
                class="btn btn-primary mt-0"
                >Export</v-btn
              >
            </div>
          </CRow>

          <CRow>
            <CCol sm="12">
              <div class="overflow-auto">
                <!-- changes done by durgesh on 21-1-2022 -->
                <table class="table userlistTable subscriptable">
                  <thead>
                    <tr class="table-success">
                      <!-- 0 -->
                      <th scope="col" class="min-width-50">Sr No.</th>
                      <th scope="col" class="min-width-120">
                        Name of the plan
                      </th>
                      <th scope="col" class="min-width-120">
                        Date of Purchase
                      </th>
                      <th scope="col" class="min-width-120">
                        Plan Activation Date
                      </th>
                      <th scope="col" class="min-width-130">Expiry Date</th>
                      <th scope="col">Paid amount</th>
                      <th scope="col" class="min-width-120">Mode of Payment</th>
                      <th scope="col">Offers</th>
                      <th scope="col">Validity of plan</th>
                      <th scope="col">Status</th>
                      <th scope="col">Action</th>
                    </tr>
                  </thead>

                  <tbody>
                    <tr>
                      <td colspan="10">
                        <v-skeleton-loader
                          v-if="showLoader"
                          type="list-item-avatar, divider,list-item-avatar, divider,list-item-avatar, divider,list-item-avatar, divider,list-item-avatar,
                   divider,list-item-avatar,divider,list-item-avatar,divider,list-item-avatar,divider,list-item-avatar,divider,list-item-avatar"
                        ></v-skeleton-loader>
                      </td>
                    </tr>
                    <tr v-for="(item, i) in historyList" :key="i">
                      <!-- Sr No. -->
                      <td>{{ i + 1 }}</td>

                      <!-- Name of the plan -->
                      <td>{{ item.name }}</td>

                      <!-- Date of Purchase -->
                      <td>
                        {{
                          item.date_of_purchase
                            ? dayJS(item.date_of_purchase).format(
                                formats.date_format
                              )
                            : "&#8213;"
                        }}
                      </td>

                      <!-- Plan Activation Date -->
                      <td>
                        {{
                          item.activation_date
                            ? dayJS(item.activation_date).format(
                                formats.date_format
                              )
                            : "&#8213;"
                        }}
                      </td>

                      <!-- Expiry Date -->
                      <td>
                        {{
                          item.expiration_date
                            ? dayJS(item.expiration_date).format(
                                formats.date_format
                              )
                            : "&#8213;"
                        }}
                      </td>

                      <!-- paid amount -->
                      <td>
                        {{ item.paid_amount ? item.paid_amount : "&#8213;" }}
                      </td>

                      <!-- Mode of Payment -->
                      <td>
                        {{
                          item.mode_of_payment
                            ? item.mode_of_payment
                            : "&#8213;"
                        }}
                      </td>

                      <!-- Offers -->

                      <td>{{ "&#8213;" }}</td>

                      <!-- Validity of plan -->
                      <td>
                        {{
                          item.validity ? `${item.validity} days` : "&#8213;"
                        }}
                      </td>

                      <!-- Status -->
                      <td>{{ item.status ? item.status : "&#8213;" }}</td>

                      <!-- Action -->
                      <td class="action-div small-table-padding border-bottom">
                        <!-- <div> -->
                        <CDropdown
                          color="link"
                          size="lg"
                          :caret="false"
                          class="dropdowndocbox"
                          v-if="item.mode_of_payment != 'Free'"
                        >
                          <template #toggler-content>
                            <verticalDotsSVG />
                          </template>
                          <CDropdownItem
                            @click="showInvoiceDialog(item.transaction_id)"
                          >
                            View Invoice
                          </CDropdownItem>
                        </CDropdown>
                        <span v-else>-</span>
                        <!-- </div> -->
                      </td>
                    </tr>

                    <tr v-if="isEmpty">
                      <td colspan="10">
                        <div>
                          <h2 class="text-center">No Data Found</h2>
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </CCol>

            <!-- this filter for active user page end -->
          </CRow>
          <pagination
            v-if="!isEmpty"
            class="mx-6"
            :currentPage="currentPage"
            :recordPerPage="recordPerPage"
            :total="total"
            @changePage="changePage"
          />
        </v-card-text>
      </v-card>
    </div>
    <v-dialog
      v-model="invoiceDialog"
      v-if="invoiceDialog"
      width="800"
      content-class="v-dialog-lg"
      scrollable
      persistent
    >
      <pdf-html
        title="Invoice"
        subject="invoiceDr"
        HidePrintButton
        HideDownloadButton
        :identifier="invoiceId"
        @close="closeInvoiceDialog"
      ></pdf-html>
    </v-dialog>
  </div>
</template>

<script>
import config from "@/config.js";
import { pickSvg } from "@/views/SVG";
import Datepicker from "v-calendar/lib/components/date-picker.umd";
const dayJS = require("@/methods/dayjs")
  .advancedFormat()
  .customParseFormat()
  .build();
import formats from "@/formats";
import { bus } from "@/main.js";
import { mapGetters } from "vuex";
export default {
  computed: {
    ...mapGetters({
      permissions: "getPermissions",
    }),
  },
  data() {
    return {
      invoiceDialog: false,
      invoiceId: "",
      lastSeenDateRange: {},
      joinOnDateRange: { start: "", end: "" },
      datePickerConfig: {
        start: {
          timeAdjust: "00:00:00",
        },
        end: {
          timeAdjust: "23:59:59",
        },
      },
      inactiveDays: { fromDateRange: 7, toDateRange: 1 },
      dateRangeActive: false,
      showLoader: false,
      role: "ambulance",
      userId: "",
      centerId: "",
      ambulanceLocationId: "",
      historyList: [],
      userDetails: {},
      userInfo: {},
      currentStatus: "all",
      dayJS,
      formats,
      isEmpty: false,
      currentPage: 1,
      recordPerPage: 10,
      totalPage: 1,
      total: 0,
      csvLoader: false,
    };
  },
  components: {
    ...pickSvg("verticalDotsSVG", "nonverifiedUserSVG", "verifiedUserSVG"),
    Datepicker,
    pagination: () => import("@/views/common/Pagination"),
    PdfHtml: () => import("@/components/PdfHtml"),
  },
  mounted() {
    this.userDetails = this.$route.query;
    this.getHistory();
  },
  methods: {
    closeInvoiceDialog() {
      this.invoiceDialog = false;
      this.invoiceId = "";
    },
    showInvoiceDialog(id) {
      this.invoiceId = id;
      this.invoiceDialog = true;
    },
    downloadCsv() {
      this.csvLoader = true;
      let params = {
        ...this.userDetails,
        start_date: this.joinOnDateRange.start.toString(),
        end_date: this.joinOnDateRange.end.toString(),
        page: this.currentPage,
        status: this.currentStatus,
      };
      let url = `${config.BASE_URL}api/v2/admin/subscription/history/csv`;
      this.$http.get(url, { params }).then((response) => {
        if (response.body.status) {
          this.csvLoader = false;
          const data = response.data.data;
          this.download(data.fileName, data.csv);
        }
      });
    },
    download(filename, text) {
      var element = document.createElement("a");
      element.setAttribute(
        "href",
        "data:text/plain;charset=utf-8," + encodeURIComponent(text)
      );
      element.setAttribute("download", filename);

      element.style.display = "none";
      document.body.appendChild(element);

      element.click();

      document.body.removeChild(element);
    },
    // change page logic
    changePage(page) {
      this.formData.page = page.currentPage;
      this.getSubscriptionList();
    },
    filterChange(data) {
      this.getHistory();
    },
    resetJoiningDate() {
      this.joinOnDateRange = { start: "", end: "" };
      this.getHistory();
    },
    resetActiveDate() {
      this.lastSeenDateRange = {};
      if (this.durationFilter) {
        this.fromDate = dayjs().subtract(7, "d").toISOString();
        this.toDate = dayjs().subtract(0, "d").toISOString();
      }
      this.getHistory();
    },
    dateChange() {
      this.getHistory();
    },

    getHistory() {
      this.showLoader = true;
      let params = {
        ...this.userDetails,
        start_date: this.joinOnDateRange.start.toString(),
        end_date: this.joinOnDateRange.end.toString(),
        page: this.currentPage,
        status: this.currentStatus,
      };
      let url;
      if (this.userDetails.role === "doctor" || this.userDetails.role === "allied")
        url = `${config.BASE_URL}api/v2/admin/subscription/history`;
      else
        url = `${config.SUBSCRIPTIONS_URL}api/v1/admin/subscriptions/history`;
      this.$http.get(url, { params }).then((response) => {
        if (response.body.status) {
          if (response.body.data) {
            bus.$emit("CHAT_BREADCRUMB_CHANGE", [
              {
                text: "Home",
                disabled: !this.permissions.includes("VIEW_DASHBOARD"),
                to: "/dashboard",
              },
              {
                text: "Subscription List",
                disabled: false,
                to: "/subscription-list",
              },
              {
                text: this.$route.name,
                disabled: true,
                to: this.$route.path,
              },
            ]);
            this.showLoader = false;
            this.userInfo = response.body.data.user_info;
            this.totalPage =
              response.body.data.subscription.count / this.recordPerPage;
            if (
              response.body.data.subscription.count % this.recordPerPage !==
              0
            )
              this.totalPage = parseInt(JSON.stringify(this.totalPage)) + 1;
            this.total = response.body.data.subscription.count;
            this.historyList = response.body.data.subscription.list;
            if (this.historyList.length <= 0) {
              this.isEmpty = true;
            } else {
              this.isEmpty = false;
            }
          } else {
            this.showLoader = false;
            this.historyList = [];
          }
        }
      });
    },
  },
};
</script>